<div class="select-trigger" #trigger="cdkOverlayOrigin" cdkOverlayOrigin (click)="toggleDropdown()"
    [class.select-trigger-xs]="size() === 'xs'" [class.select-trigger-sm]="size() === 'sm'"
    [class.select-trigger-lg]="size() === 'lg'">
    @if(title()) {
    {{ title() }}
    }
    <ng-content select=".dropdown-icon"></ng-content>
</div>
<ng-template #dropdownTemplate>
    <div class="select-dropdown" role="listbox">
        <ng-content></ng-content>
    </div>
</ng-template>
